import Cookies from 'universal-cookie';
import { OPTIMIZELY_USER_GROUP } from 'config/constants';

const cookies = new Cookies();

const getOptimizelyUserGroup = (): string | null => cookies.get<string | null>(OPTIMIZELY_USER_GROUP) || null;

export default getOptimizelyUserGroup;
